import { render, staticRenderFns } from "./vendorLabel.vue?vue&type=template&id=797dbdaa&scoped=true&"
import script from "./vendorLabel.vue?vue&type=script&lang=js&"
export * from "./vendorLabel.vue?vue&type=script&lang=js&"
import style0 from "./vendorLabel.vue?vue&type=style&index=0&id=797dbdaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797dbdaa",
  null
  
)

export default component.exports